module.exports = __webpack_public_path__ + "img/om-logo.1732b524.svg";